<template>
  <div class="body-container import-order-list big-list">
    <div class="head-box">
      <van-tabs v-model="activeIndex" @change='tabClick' class="list-tabs small">
        <van-tab title="全部" name=""></van-tab>
        <van-tab title="保障中" name="1"></van-tab>
        <van-tab title="待续保" name="2"></van-tab>
        <van-tab title="已终止" name="4"></van-tab>
      </van-tabs>
    </div>
    <van-list v-model="listLoading" :finished="finished" :finished-text="finishedText" @load="nextPage" class="list-content order-list">
      <van-cell v-for="(item, index) in list" :key="index">
        <div class="list-item" @click="goPage('/m/order/detail?flag=policy&plat='+item.plat+'&pageFlag=orderOrPolicy&policyNo='+item.policyNo)">
          <div class="top-box">
            <div class="text">投保时间：{{item.createTime | timeStatus}}</div>
          </div>
          <div class="content-box">
            <div class="title">{{item.productName}}</div>
            <div class="left-box">
              <div class="text"><span class="label">投/被保人：</span>{{item.policyerName}}<span v-if="item.policyerName&&item.insuranceName">/</span>{{item.insuranceName}}</div>
              <div class="text"><span class="label">保障期限：</span>{{item.startTime|timeSplit}}至{{item.endTime|filterEndTime}}</div>
              <div class="text"><span class="label">保费：</span>{{item.fee|filterFee}}元</div>
            </div>
            <img src="@static/images/order/icon-gl.png" class="icon">
          </div>
          <div class="bottom-box">
            <van-button plain class="btn" type="info" @click.stop="del(item)">取消关联</van-button>
          </div>
        </div>
      </van-cell>

      <div class="null" v-if="list.length<=0&&!listLoading">
        <img class="null-img" src="@static/images/null2.png">
        <span class="null-text">暂无保单</span>
      </div>
    </van-list>
    <div class="page-bottom-box">
      <van-button class="btn" type="info" @click="goPage('/m/order/importOrder')">添加保单</van-button>
    </div>
  </div>
</template>

<script>
import {pageTools,common} from "@/api/mixins";
export default {
  mixins:[pageTools,common],
  components:{},
  data() {
    return {
      orderOrPolicy:'orderOrPolicy',
      listLoading:false,
      showSelectPanel:false,//账户类型弹窗
      type:"1",
      typeName:"全部账户",
      name: "",//投/被人姓名
      startTime:"",
      endTime:"",
      incomes:"",//服务费
      totalFee:"",//保费
      ordersNum:"",//订单数
      activeIndex: "",
      list:[],
    };
  },
  created(){
  },
  mounted() {
    if(!this.checkLogin()){
      return;
    }
    if(sessionStorage.bdgjImportOrderTab) {
      this.activeIndex = sessionStorage.bdgjImportOrderTab;
    }
    // 查询订单列表
    this.$weixin.hideMenu();
    this.initListAjax("/api/getMyPolicy")
  },
  methods: {
    listCallback(res){
      this.listLoading = false;
      this.list = res.data;
    },
    //设置产品参数
    setListParams(params){
      this.listLoading = true;
      params.policyStatus = this.activeIndex;
      params.resource = 2;

      return params
    },
    tabClick(){
      // console.log(this.activeIndex)
      sessionStorage.bdgjImportOrderTab = this.activeIndex;
      this.list = [];
      this.searchAjax();
    },
    // 删除
    del(item){
      this.$notice.inquiry("确定取消关联保单？",["确定","取消"],()=>{
        this.$http({
          type: "PUT",
          url: "/api/bplat/delEnteryPolicy/"+item.id,
          data: {}
        }).then(res=>{
          this.$notice.msg("取消关联保单成功");
          const index = this.list.findIndex((bean)=>{
            return bean.id == item.id;
          });
          this.list.splice(index,1)
          if(this.list.length==0){
            this.finishedText = "";
          }
        });
      })
    },
  },
  filters:{
    filterEndTime(val){
      if(val=='2888-01-01 00:00:00'){
        return '终身'
      }else if (!val) {
        return;
      }else{
        return val.substring(0, 10).replace(/-/g,'/');
      }
    },
    filterFee(val){
      if(!val){
        return '0.00'
      }else{
        return val.toFixed(2)
      }
    }
  }

};
</script>

<style lang="scss" scoped>
@import "./importOrderList";
.import-order-list .list-item .bottom-box .btn {
  width: auto;
}
</style>
